import { useEffect } from 'react';

export const useOnMount = (onMount) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onMount, []);
};
